import Enumerator from '../global/Enumerator';

export const assetTypes = [
  'owner_occupier_property_address',
  'investment_property_address',
  'vehicle_make_and_model',
  'bank_accounts',
  'home_contents',
  'kiwisaver',
  'superfund_institution',
  'shares',
  'other',
  'balance_sheet'
];

export class AssetType extends Enumerator {
  static default() {
    return this.of('owner_occupier_property_address');
  }
}

AssetType.initEnum({
  owner_occupier_property_address: {
    get id() {
      return 'owner_occupier_property_address';
    },
    get title() {
      return 'Owner occupier property address';
    },
    get weight() {
      return 1;
    }
  },
  investment_property_address: {
    get id() {
      return 'investment_property_address';
    },
    get title() {
      return 'Investment property address';
    },
    get weight() {
      return 2;
    }
  },
  vehicle_make_and_model: {
    get id() {
      return 'vehicle_make_and_model';
    },
    get title() {
      return 'Vehicle make and model';
    },
    get weight() {
      return 3;
    }
  },
  bank_accounts: {
    get id() {
      return 'bank_accounts';
    },
    get title() {
      return 'Bank accounts';
    },
    get weight() {
      return 4;
    }
  },
  home_contents: {
    get id() {
      return 'home_contents';
    },
    get title() {
      return 'Home contents';
    },
    get weight() {
      return 5;
    }
  },
  kiwisaver: {
    get id() {
      return 'kiwisaver';
    },
    get title() {
      return 'KiwiSaver';
    },
    get weight() {
      return 6;
    }
  },
  superfund_institution: {
    get id() {
      return 'superfund_institution';
    },
    get title() {
      return 'Super fund institution';
    },
    get weight() {
      return 7;
    }
  },
  shares: {
    get id() {
      return 'shares';
    },
    get title() {
      return 'Shares';
    },
    get weight() {
      return 8;
    }
  },
  other: {
    get id() {
      return 'other';
    },
    get title() {
      return 'Other';
    },
    get weight() {
      return 9;
    }
  },
  balance_sheet: {
    get id() {
      return 'balance_sheet';
    },
    get title() {
      return 'Balance sheet';
    },
    get weight() {
      return 10;
    }
  }
});

export default {
  assetTypes,
  AssetType
};
